import { Environment } from './Logger';

export const isUnderTest = () =>
  window.env.environment === Environment.featureBranch ||
  window.env.environment === Environment.test ||
  window.env.environment === Environment.ovrigtEniac;
export const isDevelopment = import.meta.env.MODE === 'development';
export default isDevelopment;
